import { render } from "./log-in.vue?vue&type=template&id=08eb755d"
import script from "./log-in.vue?vue&type=script&lang=js"
export * from "./log-in.vue?vue&type=script&lang=js"
script.render = render

export default script